import { Component, NgZone, ViewChild } from '@angular/core';
import { MatStepper } from '@angular/material/stepper';
import { Router } from '@angular/router';
import { Users } from 'server/shared/collections/users';
import { trimPhone } from 'server/shared/helpers/trimPhoneHelper';
import { SexEnum } from 'server/shared/models/sex.enum';
import { User } from 'server/shared/models/user';
import { ToastService } from '../../services/toast/toast.service';
import { SubscriptionService } from '../../shared/subscription.service';

@Component({
  selector: 'complete-profile',
  templateUrl: 'complete-profile.component.html',
  styleUrls: ['complete-profile.component.scss'],
})
export class CompleteProfileComponent {
  sexEnum = SexEnum;
  confirmationCode: string = 'IN-';
  justClickedResendEmail = false;
  justClickedResendSms = false;
  user: Partial<User> = {
    sex: undefined,
    firstName: '',
    lastName: '',
  };

  userTracker: any;

  @ViewChild('stepper', { static: false }) stepper?: MatStepper;

  constructor(
    private router: Router,
    private ngZone: NgZone,
    private toastService: ToastService,
    private subscriptionService: SubscriptionService,
  ) {}

  ngOnInit() {
    this.userTracker = Tracker.autorun(() => {
      let user = Users.findOne(Meteor.userId());
      if (user) {
        if (user.isInSetup) {
          this.ngZone.run(() => {
            this.user = user;
            if (this.user.phoneConfirmed && this.user.emailConfirmed) {
              this.subscriptionService.subscribe();
              this.router.navigate(['/profile']).then();
            }
          });
        } else if (user.email) {
          // user.email checks if we get the full user and not just the meteor user
          this.router.navigate(['/']).then();
        }
      }
    });
  }

  trimPhone() {
    if (this.user?.phone) {
      this.user.phone = trimPhone(this.user.phone);
    }
  }

  sendNewPhoneToken() {
    this.justClickedResendSms = true;
    setTimeout(() => {
      this.justClickedResendSms = false;
    }, 10000);
    Meteor.call('newPhoneToken', this.user.phone, (error: Meteor.Error) => {
      if (error) {
        this.toastService.add({ type: 'ERROR', message: 'serverError' });
      } else {
        this.toastService.add({ type: 'SUCCESS', message: 'sentNewSMSToken' });
      }
    });
  }

  sendNewEmailToken() {
    this.justClickedResendEmail = true;
    setTimeout(() => {
      this.justClickedResendEmail = false;
    }, 2000);
    Meteor.call('reSendEnrollEmail', (error: Meteor.Error, success: any) => {
      if (error) {
        this.toastService.add({ type: 'ERROR', message: 'serverError' });
        return;
      }
      if (success) {
        this.toastService.add({ type: 'SUCCESS', message: 'sentNewSMSToken' });
      }
    });
  }

  submitNameStep() {
    this.stepper?.next();
    Meteor.call(
      'updateProfileFirstStep',
      this.user.sex,
      this.user.firstName,
      this.user.lastName,
      (error: Meteor.Error, success: any) => {
        if (!success) {
          this.stepper?.previous();
          this.toastService.add({ type: 'ERROR', message: 'serverError' });
        }
      },
    );
  }

  submitPhoneStep() {
    if (!this.user.phone) {
      this.toastService.add({ type: 'ERROR', message: 'fieldsRequired' });
      return;
    } else {
      this.trimPhone();
      this.ngZone.run(() => {
        this.stepper?.next();
      });
      Meteor.call('newPhoneToken', this.user.phone, (error: Meteor.Error) => {
        if (error) {
          if (error.error == 'PhoneAlreadyInUse') {
            this.toastService.add({
              type: 'ERROR',
              message: 'phoneNumberOccupied',
            });
          } else {
            console.log(error);
            this.toastService.add({ type: 'ERROR', message: 'serverError' });
          }
          this.ngZone.run(() => {
            this.stepper?.previous();
          });
        }
      });
    }
  }

  submitConfirmStep() {
    if (!this.confirmationCode || this.confirmationCode == 'IN-') {
      this.toastService.add({ type: 'ERROR', message: 'fieldsRequired' });
      return;
    }
    Meteor.call(
      'verifySMSToken',
      this.user.phone,
      this.confirmationCode,
      (error: Meteor.Error) => {
        if (error) {
          if (error.error == 'OptInNotFound') {
            this.toastService.add({
              type: 'ERROR',
              message: 'wrongOrExpiredToken',
            });
          } else {
            console.log(error);
            this.toastService.add({ type: 'ERROR', message: 'serverError' });
          }
        } else {
          this.ngZone.run(() => {
            this.user.phoneConfirmed = true;
          });
        }
      },
    );
  }

  ngOnDestroy() {
    if (this.userTracker) {
      this.userTracker.stop();
    }
  }
}
